import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { AppLayout, ProtectedRoutesLayout } from '@forwardflow/layouts'
// import { lazy } from 'react'

import ProtectRoutes from './ProtectedRoutes/ProtectedRoutes'
import SettingsLayout from '@forwardflow/layouts/SettingsLayout'
import Signup from '../pages/SignUp'
import Signin from '../pages/SignIn'
import ForgotPassword from '../pages/ForgotPassword'
import SetNewPassword from '../pages/SetNewPassword'
import Dashboard from '../pages/Dashboard'

import OnboardingPage from '@forwardflow/pages/Onboarding/OnboardingPage'

import VerifyEmail from '../pages/Onboarding/VerifyEmail'
import CampaignLayout from '../layouts/CampaignLayout'
import PhoneNumberLayout from '../layouts/PhoneNumberLayout'
import Calendar from '../pages/Calendar'
import Conversations from '../pages/Conversations'
import NotFound from '../pages/NotFound'
import Terms from '../pages/Terms'
import Privacy from '../pages/Privacy'
import DemoSignup from '../pages/DemoSignUp'
import Logout from '@forwardflow/components/Logout'
// import CombinedRouteProtection from './CombinedProtectedRoutes/CombinedProtectedRoutes'
import * as Sentry from '@sentry/react'
import MarketingAnalytics from '@forwardflow/pages/MarketingAnalytics'
import DemoConversationLayout from '@forwardflow/layouts/DemoConversationLayout'
import SelectUserOrganization from '@forwardflow/components/SelectUserOrganization'

import RoleBasedRoute from './RoleBasedRoute/RoleBasedRoute'
import ConversationLayout from '@forwardflow/layouts/ConversationLayout'
import { PhoneNumberManagementPage } from '@forwardflow/pages/phone-number-management/PhoneNumberManagementPage'

// const isDevEnvironment = () => {
//    const hostname = window.location.hostname
//    return (
//       hostname.includes('dev-') ||
//       hostname.includes('development-') ||
//       hostname === 'localhost' ||
//       hostname.includes('127.0.0.1')
//    )
// }

const Routing = () => {
   // const isDevelopment = isDevEnvironment()
   const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)

   return (
      <>
         <BrowserRouter>
            <SentryRoutes>
               <Route element={<AppLayout />}>
                  <Route path="/" element={<Signin />} />
                  <Route path="/logout" element={<Logout />} />
                  <Route path="/verify-email" element={<VerifyEmail />}></Route>
                  <Route path="/signup" element={<Signup />} />
                  <Route path="/demo-signup" element={<DemoSignup />} />
                  <Route path="/signin" element={<Signin />} />

                  <Route path="/terms" element={<Terms />}></Route>
                  <Route path="/privacy" element={<Privacy />}></Route>
                  <Route
                     path="/forgot-password"
                     element={<ForgotPassword />}
                  ></Route>
                  <Route
                     path="/set-new-password"
                     element={<SetNewPassword />}
                  />
                  <Route element={<ProtectedRoutesLayout />}>
                     <Route element={<ProtectRoutes />}>
                        <Route
                           path="/initializing"
                           element={<SelectUserOrganization />}
                        />
                        <Route
                           path="/onboarding"
                           element={<OnboardingPage />}
                        />
                        {/* Non-agent routes */}
                        <Route
                           path="/demo-conversations-old/:id"
                           element={<ConversationLayout />}
                        />
                        <Route
                           path="/demo-conversations-old"
                           element={<ConversationLayout />}
                        />
                        <Route
                           path="/demo-conversations/:id"
                           element={<DemoConversationLayout />}
                        />
                        <Route
                           path="/demo-conversations"
                           element={<DemoConversationLayout />}
                        />
                        {/* 
                        <Route
                           element={
                              <CombinedRouteProtection
                                 requireOnboarding={!isDevelopment}
                                 showFirstSignInModal={true}
                              />
                           }
                        > */}
                        <Route
                           path="/dashboard"
                           element={<Dashboard />}
                        ></Route>

                        {/* Non-agent routes */}
                        <Route
                           element={
                              <RoleBasedRoute excludedRoles={['Agent']} />
                           }
                        >
                           <Route
                              path="/campaign/*"
                              element={<CampaignLayout />}
                           ></Route>
                        </Route>
                        <Route
                           path="/marketing"
                           element={<MarketingAnalytics />}
                        ></Route>
                        <Route
                           path="/conversations/"
                           element={<Conversations />}
                        ></Route>
                        <Route
                           path="/conversations/:id"
                           element={<Conversations />}
                        ></Route>
                        <Route
                           path="/phone-numbers/*"
                           element={<PhoneNumberLayout />}
                        ></Route>
                        <Route
                           path="/settings/*"
                           element={<SettingsLayout />}
                        />
                        <Route path="/calendar/*" element={<Calendar />} />
                        <Route
                           path="/phone-number-management"
                           element={<PhoneNumberManagementPage />}
                        />
                     </Route>
                  </Route>
               </Route>
               <Route path="*" element={<NotFound />} />
               {/* </Route> */}
            </SentryRoutes>
         </BrowserRouter>
      </>
   )
}

export default Routing
